import React, { useState, useRef, useEffect } from "react";
import "./../profile.css";
import { validateEditProfile } from "../../../constant/validation";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import {
  disableGender,
  getUser,
  onlyMobile,
  onlyNumber,
} from "../../../constant/utils";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { profileAction } from "../../../redux/action";
import Loader from "react-loader-spinner";
interface IEditPtofile {
  handleUpdate: (data: any) => void;
}
const EditProfile = ({ handleUpdate }: IEditPtofile) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const USER: any = getUser();
  const [initialValue, setInitialValue] = useState<any>({
    first_name: "",
    last_name: "",
    email_id: "",
    mobile_no: "",
    dob: "",
    age: "",
    gender: "",
    salutation: "",
  });
  const master: any = useSelector(
    (state: any) => state?.profile?.profileMaster || {},
  );
  const familyMemberData: any = useSelector((state: any) =>
    state.profile.patientList ? state.profile.patientList?.[0] : {},
  );
  const profileData: any = useSelector((state: any) =>
    state.profile.profileData ? state.profile.profileData : {},
  );
  const commonLoading: any = useSelector((state: any) =>
    state.common.loader ? state.common.loader : false,
  );

  useEffect(() => {
    dispatch(profileAction.patientListAction({}));
    setInitialValue({
      first_name: profileData?.first_name || "",
      last_name: profileData?.last_name || "",
      email_id: profileData?.email_id || "",
      mobile_no: profileData?.mobile_no || "",
      dob: profileData?.dob || "",
      age: profileData?.age || "",
      gender: profileData?.gender || "",
      pid: familyMemberData?.pid,
      salutation: profileData?.salutation,
      relation: master?.relation?.[0]?.tag || "1",
    });
  }, [profileData]);

  const fileInpRef = useRef<any>();
  const clickOnInp = () => {
    fileInpRef.current?.click();
  };

  return (
    <div className="edit_profile">
      <div className="heading_box">Edit Profile</div>
      {commonLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader type="ThreeDots" color="#000" height={100} width={100} />
        </div>
      ) : (
        <div className="form_box">
          <Formik
            initialValues={initialValue}
            enableReinitialize={true}
            validationSchema={validateEditProfile}
            onSubmit={(val: any) => {
              let age = moment().diff(val?.dob, "years");
              handleUpdate({
                ...val,
                age,
                relation: master?.relation?.[0]?.tag,
              });
            }}
            render={({
              values,
              handleChange,
              errors,
              touched,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }: any) => (
              <form onSubmit={handleSubmit}>
                <div className="d-flex align-items-end mb-3">
                  <div className="profile_upload_inp">
                    <div className="profile_upload">
                      {profileData?.first_name?.length > 0 ? (
                        profileData?.first_name?.charAt(0)?.toUpperCase()
                      ) : (
                        <img src="/assets/img/user.png" alt="" />
                      )}
                    </div>
                    {/* <img
                    src="/assets/img/my-profile/camera.png"
                    alt=""
                    className="cursor-pointer ml-3"
                    onClick={clickOnInp}
                  />
                  <input
                    type="file"
                    ref={fileInpRef}
                    style={{ display: "none" }}
                    accept="image/*"
                  /> */}
                  </div>
                  <div className="ml-4">
                    <h4 className="profile_name mb-2">{`${profileData?.first_name || ""} ${
                      profileData?.last_name || ""
                    }`}</h4>
                    <p>{profileData?.email_id || ""}</p>
                  </div>
                </div>
                <div className="row align-items-start">
                  <div className="col-sm-2">
                    <div className="form-group">
                      <label className="profileLabel">Salutation*</label>
                      <select
                        name="salutation"
                        className="form-control profileInp"
                        // onChange={(e: any) => {
                        //   handleChange(e);
                        //   setFieldValue("gender", "");
                        // }}

                        onChange={(e: any) => {
                          handleChange(e);
                          const salutation = e.target.value;

                          const male = ["mr", "master", "ho", "bo"];
                          const female = [ "mrs", "ms", "miss", "madam", "sister", "wo"];

                          setFieldValue("salutation", salutation);

                          if (male.includes(salutation)) {
                            setFieldValue("gender", "male");
                          } else if (female.includes(salutation)) {
                            setFieldValue("gender", "female");
                          } else {
                            setFieldValue("gender", "others");
                          }
                        }}
                        onBlur={handleBlur}
                        value={values?.salutation}
                      >
                        <option value="">Salutation</option>
                        {master?.salutation?.map((ele: any) => (
                          <option value={ele?.tag}> {ele?.title}</option>
                        ))}
                      </select>
                      {touched?.salutation && errors?.salutation && (
                        <span className="error_message">
                          {errors?.salutation}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label className="profileLabel">First Name*</label>
                      <input
                        type="text"
                        name="first_name"
                        className="form-control profileInp"
                        placeholder="Enter First Name"
                        onChange={handleChange}
                        onBlur={(event) =>
                          setFieldValue(
                            event.target.name,
                            event.target.value.trim(),
                          )
                        }
                        value={values?.first_name}
                        onInput={(e: any) => {
                          return (e.target.value = e.target.value
                            .replace(/[^a-z0-9\s]/gi, "")
                            .replace(/\s{2,}/g, " "));
                        }}
                      />
                      {touched?.first_name && errors?.first_name && (
                        <span className="error_message">
                          {errors?.first_name}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="profileLabel">Last Name*</label>
                      <input
                        type="text"
                        name="last_name"
                        className="form-control profileInp"
                        placeholder="Enter Last Name"
                        onChange={handleChange}
                        onBlur={(event) =>
                          setFieldValue(
                            event.target.name,
                            event.target.value.trim(),
                          )
                        }
                        value={values?.last_name}
                        onInput={(e: any) => {
                          return (e.target.value = e.target.value
                            .replace(/[^a-z0-9\s]/gi, "")
                            .replace(/\s{2,}/g, " "));
                        }}
                      />
                      {touched?.last_name && errors?.last_name && (
                        <span className="error_message">
                          {errors?.last_name}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="profileLabel">Mobile Number*</label>
                      <input
                        type="text"
                        name="mobile_no"
                        className="form-control profileInp"
                        placeholder="Enter Mobile Number"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.mobile_no}
                        onInput={onlyMobile}
                        disabled={true}
                      />
                      {touched?.mobile_no && errors?.mobile_no && (
                        <span className="error_message">
                          {errors?.mobile_no}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="profileLabel">Email ID*</label>
                      <input
                        type="text"
                        name="email_id"
                        className="form-control profileInp"
                        placeholder="Enter Email ID"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.email_id}
                      />
                      {touched?.email_id && errors?.email_id && (
                        <span className="error_message">
                          {errors?.email_id}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="profileLabel">Date of Birth*</label>
                      <input
                        type="date"
                        name="dob"
                        className="form-control profileInp"
                        placeholder="Select DOB"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.dob}
                        min={moment()
                          .subtract(120, "years")
                          ?.format("YYYY-MM-DD")}
                        max={moment()
                          .subtract(5, "years")
                          ?.format("YYYY-MM-DD")}
                      />
                      {touched?.dob && errors?.dob && (
                        <span className="error_message">{errors?.dob}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="profileLabel">Gender*</label>
                      <div>
                        {master?.gender?.map((ele: any, idx: number) => (
                          <div className="form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="gender"
                              id={`flexRadioDefault${idx}`}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={ele?.tag}
                              checked={ele?.tag == values?.gender}
                              disabled={disableGender(
                                ele?.tag,
                                values?.salutation,
                              )}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`flexRadioDefault${idx}`}
                            >
                              {ele?.title}
                            </label>
                          </div>
                        ))}
                      </div>
                      {touched?.gender && errors?.gender && (
                        <span className="error_message">{errors?.gender}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 text-center">
                    <button
                      type="submit"
                      className="book--hexagon active sm_form" /* onClick={() => { file?.length == 0 && setFileErr("file upload is required.") }} */
                    >
                      <span>
                        Save Profile
                        <i
                          className="fa fa-long-arrow-right ml-20"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </button>
                  </div>
                </div>
              </form>
            )}
          />
        </div>
      )}
    </div>
  );
};

export default EditProfile;
